<script setup lang="ts">
import { onMounted } from "vue"
import { useRouter, type LocationAsRelativeRaw } from "vue-router"

const props = defineProps<{ to: LocationAsRelativeRaw }>()
const router = useRouter()

onMounted(() => router.push(props.to))
</script>
